export const MASS_DE_PSEUDO_REQUEST = 'MASS_DE_PSEUDO_REQUEST';

export const massDePseudoRequest = ({ year, module, forAllLagGs }) => ({
    type: MASS_DE_PSEUDO_REQUEST,
    payload: { year, module, forAllLagGs }
});
